
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 205 205"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M102.5 205c56.519 0 102.5-45.981 102.5-102.5S159.019 0 102.5 0 0 45.981 0 102.5 45.981 205 102.5 205zM190 102.5c0 48.248-39.252 87.5-87.5 87.5a87.17 87.17 0 01-26.799-4.203l53.578-45.719a46.568 46.568 0 006.119-5.221l.036-.031-.003-.004c8.183-8.335 13.242-19.747 13.242-32.322 0-11.978-4.586-22.903-12.092-31.117h47.697A87.088 87.088 0 01190 102.5zm-117.919 6.793a31.163 31.163 0 01-.754-6.793c0-16.907 13.532-30.704 30.333-31.151v.035h2.646c16.351.938 29.368 14.534 29.368 31.117 0 8.271-3.244 15.793-8.518 21.379l-5.189 4.428a30.997 30.997 0 01-17.466 5.366c-12.685 0-23.617-7.62-28.479-18.519l.037-.012-1.978-5.85zM102.5 15c31.334 0 58.869 16.56 74.328 41.383h-72.114a46.466 46.466 0 00-2.214-.056c-17.303 0-32.404 9.572-40.311 23.694l-15.235-45.08C62.074 22.488 81.429 15 102.5 15zM35.111 46.75l22.534 66.679c4.466 18.327 19.893 32.395 38.917 34.85l-36.197 30.887C33.345 164.256 15 135.481 15 102.5c0-21.167 7.556-40.601 20.111-55.75z"}})])
          )
        }
      }
    